import React, { Component } from "react";
import { Divider, Message, Segment } from "semantic-ui-react";
import axios from "axios";
import { ImageUploadSection } from "./ImageUploadSection";
import SupplementalModal from "./SupplementalModal";
import PropTypes from "prop-types";

let baseUrl = "dealer";

export class ImageReupload extends Component {
  state = {
    loading: false,
    reqResponse: null,
    supplementalData: null,
  };

  onUpload = (e, entity, systemId = null, certId = null) => {
    let fieldName = "";

    switch (e.target.name) {
      case "image1":
        fieldName = "voided_check";
        break;
      case "image2":
        fieldName = "drivers_license";
        break;
      case "image3":
        fieldName = "proof_of_income";
        break;
      case "image4":
        fieldName = "proof_of_residence";
        break;
      case "image5":
        fieldName = "drivers_license";
        break;
      case "image6":
        fieldName = "proof_of_income";
        break;
      case "image7":
        fieldName = "proof_of_residence";
        break;
      case "image8":
        fieldName = "signed_ach_authorization";
        break;
      case "image9":
        fieldName = "bill_of_sale";
        break;
      default:
        fieldName = "registration_certificate";
        break;
    }

    const fieldNameHyphenated = fieldName.replace(/_/g, "-");
    const idKey = entity === "contract" ? "contract_id" : "corenter_id";
    const idValue =
      entity === "contract" ? this.props.contractId : this.props[`${entity}Id`];

    const data = new FormData();
    data.append(fieldName, e.target.files[0]);
    data.append(idKey, idValue);

    if (fieldName === "registration_certificate") {
      data.append("hvac_system_id", systemId);
      data.append("registration_certificate_id", certId);
    }

    this.setState({
      loading: true,
      reqResponse: null,
    });

    axios
      .post(`/images/${fieldNameHyphenated}/`, data)
      .then(({ data }) => {
        if (
          fieldName !== "bill_of_sale" &&
          fieldName !== "registration_certificate" &&
          fieldName !== "signed_ach_authorization" &&
          fieldName !== "proof_of_income" &&
          fieldName !== "proof_of_residence"
        ) {
          if (this.props.images.length === 1) {
            return this.markSubmitted();
          }

          this.props.fetchContract();
        } else {
          if (
            fieldName === "proof_of_income" ||
            fieldName === "proof_of_residence"
          ) {
            let docId = data.corenter_id
              ? data.id
              : data[`${fieldName}_image`]
              ? data[`${fieldName}_image`].id
              : null;

            if (!docId) return this.props.fetchContract();

            return this.showAdditionalModal({
              fieldName,
              id: docId,
              uploaded: [],
            });
          } else {
            return this.props.fetchContract();
          }
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          reqResponse: {
            content: err.response.data.ui_message,
            header: "There was a problem",
            success: false,
          },
        });

        setTimeout(() => {
          this.setState({
            reqResponse: null,
          });
        }, 5000);
      });
  };

  markSubmitted = () => {
    if (this.props.images.length === 1) {
      axios
        .post(`/modify-status/`, {
          context: "mark_submitted",
          entity_id: this.props.contractId,
        })
        .then(() => {
          this.props.fetchContract();
        })
        .then(() => this.clearSupplemental());
    } else {
      this.props.fetchContract();
      this.clearSupplemental();
    }
  };

  onSupplementalDelete = (filename) => {
    if (!filename) return;

    axios.delete(`/images/supplemental-document/${filename}/`).then(() =>
      this.setState({
        supplementalData: {
          ...this.state.supplementalData,
          uploaded: this.state.supplementalData.uploaded.filter(
            (f) => f.filename !== filename
          ),
        },
      })
    );
  };

  onSupplementalUpload = (e) => {
    const { supplementalData } = this.state;

    if (
      !e.target.files ||
      !e.target.files.length ||
      !supplementalData ||
      !supplementalData.id ||
      !supplementalData.fieldName
    )
      return;

    const originalFilename = e.target.files[0].name;

    const postData = new FormData();

    postData.append("supplemental_document", e.target.files[0]);
    postData.append(
      `${supplementalData.fieldName}_image_id`,
      supplementalData.id
    );

    axios.post(`/images/supplemental-document/`, postData).then(({ data }) => {
      this.setState({
        supplementalData: {
          ...this.state.supplementalData,
          uploaded: [
            ...this.state.supplementalData.uploaded,
            { ...data, originalFilename },
          ],
        },
      });
    });
  };

  onSupplementalDecline = () => {};

  showAdditionalModal = (supplementalData) => {
    this.setState({ supplementalData, loading: false });
  };

  clearSupplemental = () => this.setState({ supplementalData: null });

  render() {
    const { reqResponse } = this.state;
    const { images } = this.props;
    const imageNames = images.map((i) => i.name);
    const registrationCertificates = images.filter(
      (i) => i.extra == "registration_cert"
    );

    return (
      <Segment className="no-style-segment" loading={this.state.loading}>
        <SupplementalModal
          uploaded={
            this.state.supplementalData
              ? this.state.supplementalData.uploaded
              : []
          }
          open={this.state.supplementalData ? true : false}
          onClose={this.clearSupplemental}
          onDecline={this.markSubmitted}
          onUpload={this.onSupplementalUpload}
          onSupplementalDelete={this.onSupplementalDelete}
        />
        {images.length ? (
          <Message
            icon="bullhorn"
            header="There's a problem with this contract"
            content="Images you uploaded for this contract have been rejected. Correct the issues below."
          />
        ) : (
          <Message
            icon="bullhorn"
            header="We're reviewing images"
            content="You re-uploaded images and we're reviewing them"
          />
        )}
        {reqResponse && (
          <Message
            header={reqResponse.header}
            icon={reqResponse.success ? "check" : "exclamation"}
            positive={reqResponse.success ? true : false}
            error={!reqResponse.success ? true : false}
            content={reqResponse.content}
          />
        )}
        <Divider hidden />
        {imageNames.includes("voided_check") && (
          <ImageUploadSection
            entity="contract"
            header="Voided Check"
            inputName="image1"
            onUpload={this.onUpload}
            notes={
              images.find((i) => i.name === "voided_check").rejection_notes
            }
            subheader="Fix the problem(s) with the voided check below"
            url={`/${baseUrl}/api/images/voided-check/${
              images.find((i) => i.name === "voided_check").filename
            }`}
          />
        )}
        {imageNames.includes("renter_dl") && (
          <ImageUploadSection
            entity="contract"
            header="Renter Driver's License"
            inputName="image2"
            onUpload={this.onUpload}
            notes={images.find((i) => i.name === "renter_dl").rejection_notes}
            subheader="Fix the problem(s) with the driver's license below"
            url={`/${baseUrl}/api/images/drivers-license/${
              images.find((i) => i.name === "renter_dl").filename
            }`}
          />
        )}
        {imageNames.includes("renter_poi") && (
          <ImageUploadSection
            entity="contract"
            header="Renter Proof of Income"
            inputName="image3"
            onUpload={this.onUpload}
            notes={images.find((i) => i.name === "renter_poi").rejection_notes}
            subheader="Fix the problem(s) with the proof of income below"
            url={`/${baseUrl}/api/images/proof-of-income/${
              images.find((i) => i.name === "renter_poi").filename
            }`}
          />
        )}
        {imageNames.includes("renter_por") && (
          <ImageUploadSection
            entity="contract"
            header="Renter Current Mortgage Statement"
            inputName="image4"
            onUpload={this.onUpload}
            notes={images.find((i) => i.name === "renter_por").rejection_notes}
            subheader="Fix the problem(s) with the Current Mortgage Statement below"
            url={`/${baseUrl}/api/images/proof-of-residence/${
              images.find((i) => i.name === "renter_por").filename
            }`}
          />
        )}
        {imageNames.includes("corenter_dl") && (
          <ImageUploadSection
            entity="coRenter"
            header="Co-Renter Driver's License"
            inputName="image5"
            onUpload={this.onUpload}
            notes={images.find((i) => i.name === "corenter_dl").rejection_notes}
            subheader="Fix the problem(s) with the driver's license below"
            url={`/${baseUrl}/api/images/drivers-license/${
              images.find((i) => i.name === "corenter_dl").filename
            }`}
          />
        )}
        {imageNames.includes("corenter_poi") && (
          <ImageUploadSection
            entity="coRenter"
            header="Co-Renter Proof of Income"
            inputName="image6"
            onUpload={this.onUpload}
            notes={
              images.find((i) => i.name === "corenter_poi").rejection_notes
            }
            subheader="Fix the problem(s) with the proof of income below"
            url={`/${baseUrl}/api/images/proof-of-income/${
              images.find((i) => i.name === "corenter_poi").filename
            }`}
          />
        )}
        {imageNames.includes("corenter_por") && (
          <ImageUploadSection
            entity="coRenter"
            header="Co-Renter Current Mortgage Statement"
            inputName="image7"
            onUpload={this.onUpload}
            notes={
              images.find((i) => i.name === "corenter_por").rejection_notes
            }
            subheader="Fix the problem(s) with the Current Mortgage Statement below"
            url={`/${baseUrl}/api/images/proof-of-residence/${
              images.find((i) => i.name === "corenter_por").filename
            }`}
          />
        )}
        {imageNames.includes("signed_ach") && (
          <ImageUploadSection
            entity="contract"
            header="Signed Payment Authorization Form (PAF)"
            inputName="image8"
            onUpload={this.onUpload}
            notes={images.find((i) => i.name === "signed_ach").rejection_notes}
            subheader="Fix the problem(s) with the Signed Payment Authorization Form (PAF) below"
            url={`/${baseUrl}/api/images/signed-ach-authorization/${
              images.find((i) => i.name === "signed_ach").filename
            }`}
          />
        )}
        {imageNames.includes("bill_of_sale") && (
          <ImageUploadSection
            entity="contract"
            header="Bill of Sale"
            inputName="image9"
            onUpload={this.onUpload}
            notes={
              images.find((i) => i.name === "bill_of_sale").rejection_notes
            }
            subheader="Fix the problem(s) with the Bill of Sale below"
            url={`/${baseUrl}/api/images/bill-of-sale/${
              images.find((i) => i.name === "bill_of_sale").filename
            }`}
          />
        )}
        {registrationCertificates.map((cert, i) => (
          <ImageUploadSection
            entity="contract"
            header={cert.name}
            inputName={`registrationCert${i + 1}`}
            onUpload={(e, d) => this.onUpload(e, d, cert.system_id, cert.id)}
            notes={cert.rejection_notes}
            subheader="Fix the problem(s) with the Registration Certificate below"
            url={`/${baseUrl}/api/images/registration-certificate/${cert.filename}`}
          />
        ))}
      </Segment>
    );
  }
}

ImageReupload.propTypes = {
  contractId: PropTypes.string,
  coRenterId: PropTypes.number,
  fetchContract: PropTypes.func,
  images: PropTypes.array,
  renterId: PropTypes.number,
};
